import { BasicContainer } from './BasicContainer';

interface Props {
  className?: string;
  isBrand?: boolean;
  isAdBannerEnabled: boolean;
}

export const InfiniteRecommendContainer = ({ className, isAdBannerEnabled }: Props) => {
  return <BasicContainer className={className} isAdBannerEnabled={isAdBannerEnabled} />;
};
